import { Pipe, PipeTransform } from '@angular/core';
import { FilterTypesEnum } from '@ui-components/models';

@Pipe({
  name: 'keyFilter'
})
export class KeyFilterPipe implements PipeTransform {

  transform(value: any[], filterValue: any, filterProperty: string, isString = false): any {
    if (!value)
      return;
    if (!filterValue ||
      (filterValue && filterValue.length == 0 ||
        filterValue == -1))
      {
        return value;
      }

    const filteredArray = [];
    value.forEach(item => {
      if (!isString) {
        if (item[filterProperty] && item[filterProperty] == filterValue)
          filteredArray.push(item);
      } else {
        if (item[filterProperty] && item[filterProperty].includes(filterValue))
          filteredArray.push(item);
      }
    });
    return filteredArray;
  }
};

@Pipe({
  name: 'textFilter'
})
export class TextFilterPipe implements PipeTransform {

  transform(value: any[], firstFilterValue, secondFilterValue: any, filterProperty: string,
    filterType: FilterTypesEnum, isViewAll = false, deptId?: any): any {
    if (!value)
      return
    if (isViewAll) {
      if ((!firstFilterValue) || (!secondFilterValue) ||
        (secondFilterValue && secondFilterValue.length == 0) &&
        (firstFilterValue && firstFilterValue.length == 0))
        return value;
    } else if (!isViewAll &&
      (!secondFilterValue || (secondFilterValue && secondFilterValue.length == 0))
      && (!firstFilterValue || (firstFilterValue && firstFilterValue.length == 0))
      && (!deptId || (deptId && deptId.length == 0))
    ) {
      return;
    }

    let filterValue = '';
    if (secondFilterValue.length > 0) {
      filterValue = secondFilterValue.toLowerCase();
    } else if (!secondFilterValue && firstFilterValue && firstFilterValue.length > 0) {
      filterValue = firstFilterValue.toLowerCase();
      filterType = FilterTypesEnum.startsWith;
    }

    switch (Number(filterType)) {
      case FilterTypesEnum.startsWith:
        return value.filter(x => x[filterProperty].toLowerCase().startsWith(filterValue));
      case FilterTypesEnum.contains:
        return value.filter(x => x[filterProperty].toLowerCase().includes(filterValue));
      case FilterTypesEnum.endsWith:
        return value.filter(x => x[filterProperty].toLowerCase().endsWith(filterValue));
    }
  }
}
